import { TinyEmitter } from "@expert/event-bus";
import type { SupportedEvents } from "./types";

export const sdkEventBus = new TinyEmitter<SupportedEvents>("task-event-fired");
